import { Route } from '@angular/router';

import { MainLayoutComponent } from './shared/components/main-layout/main-layout.component';
import { usernameGuard } from './guards/username.guard';
import type { RoomComponent } from './pages/room/room.component';

export const appRoutes: Route[] = [
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/lobby/lobby.component').then((m) => m.LobbyComponent),
        canActivate: [usernameGuard],
      },
      {
        path: 'welcome',
        loadComponent: () =>
          import('./pages/username/username.component').then(
            (m) => m.UsernameComponent
          ),
      },

      {
        path: 'sounds',
        loadComponent: () =>
          import('./pages/sounds/sounds.component').then(
            (m) => m.SoundsComponent
          ),
      },
      {
        path: 'room/:joinCode',
        loadComponent: () =>
          import('./pages/room/room.component').then((m) => m.RoomComponent),
        canActivate: [usernameGuard],
        // Navigating away from the room leaves it, after a confirmation.
        canDeactivate: [(room: RoomComponent) => room.confirmLeave()],
      },
    ],
  },
];
